/**************************************************
 * Nombre:       Home_Historias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import Tarjeta_Historias from "../../Tarjetas/Tarjeta_Historias";
import '@splidejs/react-splide/css';
import {useEffect, useRef, useState} from "react";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Home_Historias = () => {
    const {sCell} = useResponsive()
    const [historias, setHistorias] = useState([]);
    const refe = useRef(null)

    const siguiente = () => {

        if (refe.current) {
            refe.current.go('>')
        }
    }
    useEffect(() => {
        let w = [where('estado', '==', 'Publicado')]

        obtenerColWheres({col: 'historias', wheres: w}).then((dox) => {
            setHistorias(dox.data)
        })
    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                overflowX: 'hidden',

            }}
        >
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, mt: 0}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                            <Grid
                                container
                                justifyContent={'center'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <Typography
                                        sx={{color: '#262626', fontSize: sCell ? 32 : 40, fontWeight: 700, textAlign: 'center', lineHeight: 1.2}}>
                                        Historias de éxito real
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 5}}
                                      sx={{justifyContent: 'center', mt: 0}}>
                                    <Typography
                                        sx={{color: '#545454', fontSize: sCell ? 14 : 16, fontWeight: 400, textAlign: 'center'}}>
                                        Sus historias muestran cómo una decisión cambió sus vidas: desde el primer
                                        entrenamiento, hasta lograr metas que antes parecían lejanas.
                                    </Typography>
                                </Grid>


                            </Grid>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 10}}
                              sx={{justifyContent: 'flex-start', mt: 8}}>
                            <Splide
                                ref={refe}
                                aria-label="My Favorite Images" style={{width: '100%'}}
                                options={{
                                    autoplay: true,
                                    speed: 1500,
                                    rewind: true,
                                    perPage: 1,
                                    arrows: false,
                                    pagination: false,
                                    width: '100%',
                                    drag: 'false',
                                    interval: 5000,
                                    noDrag: true,
                                    gap: 20
                                }}
                            >

                                {historias.map((item, index) => {
                                    return (
                                        <SplideSlide key={`qe${index}`}>
                                            <Tarjeta_Historias item={item}/>
                                        </SplideSlide>
                                    )
                                })}
                            </Splide>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-end', mt: sCell ? 4 : -5}}>
                            <Button
                                onClick={() => siguiente()}
                                variant={'outlined'} sx={{px: 6}}>Ver Siguiente</Button>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Historias

const items = [1, 2]